import { useState, useContext } from "react"
import { Link as RouterLink, useLocation } from "react-router-dom"
import styled, { ThemeContext } from "styled-components"
import { Toggle } from "./Toggle"

const HeaderWrapper = styled.header`
  width: 100%;
  height: 70px;
  box-sizing: border-box;
  padding: 0 16px;
  display: flex;
  background: linear-gradient(
    to right,
    ${(p) => p.theme.primaryColor},
    ${(p) => p.theme.secondaryColor}
  );
  border-bottom: 2px solid #000;
`
const Menu = styled.nav`
  display: ${(p) => (p.open ? "block" : "none")};
  position: absolute;
  width: 100%;
  top: 60px;
  right: 0;
  padding: 10px;
  box-sizing: border-box;
  border-bottom: 2px solid #000;
  background: ${(p) => p.theme.thirdColor};

  @media (min-width: 768px) {
    display: flex;
    position: relative;
    margin: auto 10px;
    background: none;
    border: none;
    width: initial;
    left: initial;
    top: initial;
  }
`

const Link = ({ isActive, children, ...props }) => {
  return <RouterLink {...props}>{children}</RouterLink>
}

const StyledLink = styled(Link)`
  padding: 4px 10px;
  display: block;
  text-align: center;
  box-sizing: border-box;
  color: ${(p) => p.theme.bodyFontColor};
  margin: 0 auto;
  text-decoration: none;
  font-weight: ${(p) => (p.isActive ? "900" : "100")};
`

const MobileMenuIcon = styled.div`
  margin: auto 10px;
  width: 25px;
  > div {
    height: 3px;
    background: ${(p) => p.theme.bodyFontColor};
    margin: 5px 0;
    width: 100%;
  }
  @media (min-width: 768px) {
    display: none;
  }
`

export function Header() {
  const { pathname } = useLocation()
  const [menuOpen, setMenuOpen] = useState(false)
  const { id, setTheme } = useContext(ThemeContext)
  return (
    <HeaderWrapper>
      <Toggle isActive={id === "dark"} onToggle={setTheme} />
      <MobileMenuIcon onClick={() => setMenuOpen((s) => !s)}>
        <div />
        <div />
        <div />
      </MobileMenuIcon>
      <Menu open={menuOpen}>
        <StyledLink to="/" isActive={pathname === "/"}>
          Home
        </StyledLink>
        <StyledLink to="/login" isActive={pathname === "/login"}>
          Login
        </StyledLink>
      </Menu>
    </HeaderWrapper>
  )
}
